import { Component, forwardRef, Input, OnInit, ViewChild } from "@angular/core";
import { UtilService } from "@app/modules/shared/services/util.service";
import { GridComponent } from "@app/modules/shared/components/grid/grid.component";
import { ApiService } from "@app/modules/shared/services/base/api.service";
import { ToastService } from "@app/modules/shared/services/message/toast.service";
import { KlLoadingService } from "@app/modules/shared/services/kl-loading.service";

@Component({
  selector: "kl-user-list",
  templateUrl: "./user-list.component.html",
  styleUrls: ["./user-list.component.scss"],
})
export class UserListComponent implements OnInit {
  @Input() mode: string;
  @Input() tabId: string;
  @Input() modalId: string;
  @ViewChild("userPasswordModal", { static: true })
  private userPasswordModal: any;
  @ViewChild("userPasswordForm", { static: true })
  private userPasswordForm: any;
  @ViewChild(forwardRef(() => GridComponent), { static: true })
  gridComponent: any;

  dropdownActions = [
    {
      icon: "fal fa-building-o",
      slug: "create_password",
      method: (cell) => {
        this.userPasswordDetail.id = cell.item.id;
        this.userPasswordDetail.username = cell.item.username;
        this.userPasswordDetail.password_confirmation = "";
        this.userPasswordDetail.password = "";
        this.userPasswordModal.show();
      },
    },
  ];
  createPasswordSpinner = false;
  userPasswordInputWarning = false;
  userPasswordInputAlertMessage = "";
  userPasswordApiWarning = false;
  filterSelectItems = [
    {
      name: "fullname",
      description: "fullname",
    },
    {
      name: "username",
      description: "username",
    },
  ];
  userPasswordDetail = {
    id: null,
    username: "",
    password_confirmation: "",
    password: "",
  };
  constructor(
    private utilService: UtilService,
    private apiService: ApiService,
    private toastService: ToastService,
    private klLoadingService: KlLoadingService
  ) {}

  ngOnInit() {
    if (this.dropdownActions.length > 0) {
      this.gridComponent.actions = this.dropdownActions;
    }
  }
  createPassword() {
    if (this.userPasswordForm.valid) {
      if (
        this.userPasswordDetail.password ===
        this.userPasswordDetail.password_confirmation
      ) {
        this.createPasswordSpinner = true;
        const postObject = {
          id: this.userPasswordDetail.id,
          username: this.userPasswordDetail.username,
          password: UtilService.encryptString(this.userPasswordDetail.password),
        };
        this.apiService
          .updateData("user/password-create", postObject)
          .subscribe(
            () => {
              this.createPasswordSpinner = false;
              this.toastService.toastSuccess("password_created");
              this.userPasswordModal.hide();
            },
            (error) => {
              this.createPasswordSpinner = false;
              this.userPasswordApiWarning = true;
              this.userPasswordInputAlertMessage =
                this.utilService.alertErrorMessage(error);
            }
          );
      } else {
        this.createPasswordSpinner = false;
        this.userPasswordInputWarning = true;
        this.userPasswordInputAlertMessage = "password_not_same";
      }
    } else {
      this.createPasswordSpinner = false;
      this.userPasswordInputWarning = true;
      this.userPasswordInputAlertMessage = "required_fields_must_be_entered";
    }
  }
}
